import { credibilityItems, trustItems } from "../../data/home";
import { useInView } from "../../hooks/useInView";
import { Icon } from "../ui/Icon";

export function ReachStatistics() {
  const mapView = useInView<HTMLDivElement>(0.2);
  const valuesView = useInView<HTMLElement>(0.3);

  return (
    <div className="container reach-statistics">
      <section id="about" className="reach-section" aria-labelledby="reach-heading">
        <div className="benefits-copy">
          <h2 id="reach-heading">Why Work With an Iran-Based Sourcing Partner?</h2>
          <p className="benefits-context">Direct purchasing can be straightforward when you already know the right supplier. We add value when you need local research, alternatives and commercial coordination.</p>
          <ul>
            {trustItems.map((item) => <li key={item}><span><Icon name="check" size={13} strokeWidth={3} /></span>{item}</li>)}
          </ul>
        </div>
        <figure ref={mapView.ref} className={`map-visual ${mapView.visible ? "is-visible" : ""}`}>
          <img className="map-base" src="/assets/global-map.png" alt="Illustrative global sourcing connections originating in Iran." loading="lazy" />
          <img className="map-route-reveal" src="/assets/global-map.png" alt="" loading="lazy" />
          <figcaption>Illustrative sourcing connections — not customer or shipment coverage.</figcaption>
        </figure>
      </section>
      <section ref={valuesView.ref} className={`statistics-bar value-strip ${valuesView.visible ? "is-visible" : ""}`} aria-label="Sourcing value">
        {credibilityItems.map((item) => (
          <article className="stat-item value-item" key={item.title}>
            <Icon name={item.icon} size={30} />
            <div><strong>{item.title}</strong><span>{item.description}</span></div>
          </article>
        ))}
      </section>
    </div>
  );
}
